import FormattedMessage from 'I18n/components/FormattedMessage';
import UIList from 'UIComponents/list/UIList';
import TriggerGroupContainer from 'automation-ui-enrollment/components/common/TriggerGroupContainer';
import ScheduledEnrollmentDetails from 'automation-ui-enrollment/components/scheduledEnrollment/ScheduledEnrollmentDetails';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ScheduledEnrollmentDetailsGroup({
  enrollmentSchedule,
  objectTypeId,
  showTimeZone,
  className
}) {
  return /*#__PURE__*/_jsxs(TriggerGroupContainer, {
    className: className,
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "automation-ui-enrollment.redesign.scheduledTriggers.details.groupHeading"
    }),
    children: [/*#__PURE__*/_jsx("strong", {
      className: "display-block",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "automation-ui-enrollment.redesign.scheduledTriggers.details.heading"
      })
    }), /*#__PURE__*/_jsx(UIList, {
      styled: true,
      className: "p-left-5 m-y-0",
      children: /*#__PURE__*/_jsx(ScheduledEnrollmentDetails, {
        enrollmentSchedule: enrollmentSchedule,
        objectTypeId: objectTypeId,
        showTimeZone: showTimeZone
      })
    })]
  });
}